import { ReactNode } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Importar componentes actualizados
import NavigationLayout from '@shared/components/navigation/NavigationLayout';
import { ImpersonationBanner } from '@shared/components/ui/ImpersonationBanner';
import { Page404 } from '@shared/components/ui/NotFound';
import GuestGuard from './GuestGuard';
import { guestRoutes } from './guestRoutes';
import PermissionRoute from './PermissionRoute';
import ProtectedRoute from './ProtectedRoute';
import { ProtectedRouteConfig, protectedRoutes } from './protectedRoutes';

export interface RouteConfig {
  path: string;
  element: ReactNode;
}

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ImpersonationBanner />
      <Routes>
        {/* Public/Guest Routes */}
        <Route element={<GuestGuard />}>
          {guestRoutes.map((route, index) => (
            <Route key={`guest-${index}`} path={route.path} element={route.element} />
          ))}
        </Route>

        {/* Protected Routes with New Navigation */}
        <Route path="/" element={<ProtectedRoute />}>
          <Route path="/" element={<NavigationLayout />}>
            {protectedRoutes.map((route: ProtectedRouteConfig, index: number) => {
              return (
                <Route
                  key={`protected-${index}`}
                  path={route.path}
                  element={
                    <PermissionRoute
                      teamTypes={route.teamTypes}
                      permissions={route.permissions}
                      requireAll={route.requireAll}
                      requireRoleAdmin={route.requireRoleAdmin}
                      requireWalletVisible={route.requireWalletVisible}
                      requireCRMEnabled={route.requireCRMEnabled}
                      requireProfitabilityAccess={route.requireProfitabilityAccess}
                    >
                      {route.element}
                    </PermissionRoute>
                  }
                />
              );
            })}
          </Route>
        </Route>

        {/* Ruta catch-all para páginas no encontradas */}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
